// Метрика шрифта для физического ввода размера: оператор задаёт высоту букв
// в миллиметрах, а в config всё равно уезжает кегль (font_size_mm).
//
// Мерим cap-height, а НЕ высоту глифа «0». Проверка на всех 46 шрифтах
// db/seeds/fonts: у Alegreya Sans и Yanone Kaffeesatz минускульные (old-style)
// цифры — «0» ниже заглавных на 14–21 %. Мера по нулю дала бы у них кегль
// на четверть больше, чем у соседнего шрифта при том же введённом числе.
// Cap-height одинаков для «10», «7» и «ИВАНОВ» — ради этого и выбран.
//
// Расплата: у таких шрифтов заглавные будут 150 мм, а цифры ~118 мм.
// Для этого есть digitRatio — справочная величина под подсказку в панели.

export const FALLBACK_RATIO = 0.7     // шрифт не загружен / метрики нет
export const DIGIT_MISMATCH = 0.02    // за этим порогом цифры «не как заглавные»

// Высота глифа над базовой линией в units, 0 — если глифа нет.
// index === 0 — это .notdef, то есть символа в шрифте нет.
function glyphTop(font, char) {
  try {
    const g = font.charToGlyph(char)
    if (!g || !g.index) return 0
    const y2 = g.getBoundingBox().y2
    return Number.isFinite(y2) && y2 > 0 ? y2 : 0
  } catch {
    return 0
  }
}

// Доля cap-height от em. os2.sCapHeight первым: на всех сидовых шрифтах он
// есть и в точности равен bbox('H').y2, а читать поле дешевле, чем обходить контур.
export function capRatio(font) {
  const upem = font?.unitsPerEm
  if (!upem) return FALLBACK_RATIO
  const declared = font.tables?.os2?.sCapHeight
  const cap = (Number.isFinite(declared) && declared > 0 ? declared : 0)
           || glyphTop(font, "H")
           || glyphTop(font, "0")
  return cap > 0 ? cap / upem : FALLBACK_RATIO
}

// Доля высоты цифры «0» от em. Нужна только для подсказки «цифры ниже»;
// без глифа возвращаем capRatio, чтобы подсказка не всплыла на пустом месте.
export function digitRatio(font) {
  const upem = font?.unitsPerEm
  if (!upem) return FALLBACK_RATIO
  const top = glyphTop(font, "0")
  return top > 0 ? top / upem : capRatio(font)
}

export function capToEm(capMm, ratio) {
  const r = Number(ratio)
  const v = Number(capMm)
  if (!Number.isFinite(r) || r <= 0 || !Number.isFinite(v)) return 0
  return v / r
}

export function emToCap(emMm, ratio) {
  const r = Number(ratio)
  const v = Number(emMm)
  if (!Number.isFinite(r) || r <= 0 || !Number.isFinite(v)) return 0
  return v * r
}
